import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaUser, FaEnvelope, FaPhone, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_BASE_URL;

export default function AffiliateRegister() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const passwordRegex = /^.{6,}$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value,
    });

    if (name === "password") {
      if (!passwordRegex.test(value)) {
        setPasswordError("Password minimal 6 karakter");
      } else {
        setPasswordError("");
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!passwordRegex.test(form.password)) {
      setPasswordError("Password minimal 6 karakter");
      return;
    }

    try {
      const res = await axios.post(`${baseURL}/api/affiliate/register`, form);

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: res.data.message || "Registrasi affiliate berhasil",
      });

      setForm({
        name: "",
        email: "",
        phone: "",
        password: "",
      });

      setPasswordError("");
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err?.response?.data?.message || "Registrasi gagal",
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 font-signika">
      <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center">
          Gabung <span className="text-primary">Affiliate</span>
        </h1>

        <p className="text-center text-gray-500 mt-2 mb-6">Dapatkan komisi dengan membagikan produk kami.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center border rounded-lg px-3 py-3">
            <FaUser className="text-gray-400 mr-3" />
            <input type="text" name="name" placeholder="Nama Lengkap" className="w-full outline-none" value={form.name} onChange={handleChange} required />
          </div>

          <div className="flex items-center border rounded-lg px-3 py-3">
            <FaEnvelope className="text-gray-400 mr-3" />
            <input type="email" name="email" placeholder="Email" className="w-full outline-none" value={form.email} onChange={handleChange} required />
          </div>

          <div className="flex items-center border rounded-lg px-3 py-3">
            <FaPhone className="text-gray-400 mr-3" />
            <input type="text" name="phone" placeholder="No. HP" className="w-full outline-none" value={form.phone} onChange={handleChange} required />
          </div>

          {/* PASSWORD */}
          <div>
            <div className={`flex items-center border rounded-lg px-3 py-3 ${passwordError ? "border-red-500" : ""}`}>
              <FaUser className="text-gray-400 mr-3" />

              <input type={showPassword ? "text" : "password"} name="password" placeholder="Password" className="w-full outline-none" value={form.password} onChange={handleChange} required />

              <div className="cursor-pointer text-gray-400" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>

            {passwordError && <p className="text-red-500 text-sm mt-1">{passwordError}</p>}
          </div>

          <button type="submit" className="w-full bg-primary hover:bg-purple-600 text-white py-3 rounded-lg font-semibold">
            Daftar Affiliate
          </button>

          <div>
            <Link to={"/login/affiliate"}>
              <p className="text-center text-primary2 underline">
                Sudah Punya Akun ? <span className="text-semibold">Login</span>
              </p>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
